module.exports = __webpack_public_path__ + "static/media/ProtectThePublicTrust_VideoScript_1596638811461.c0613d76.docx";